import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problem } from "@/components/landing/Problem";
import { Chapters } from "@/components/landing/Chapters";
import { Principles } from "@/components/landing/Principles";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { Lightbox } from "@/components/landing/Lightbox";
import { Privacy } from "@/components/landing/Privacy";

const Landing = () => {
    const [lightbox, setLightbox] = useState(null);
    const closeLightbox = useCallback(() => setLightbox(null), []);

    return (
        <div className="grain min-h-screen bg-[#0D0C0B] text-[#F4F1EC]">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Problem />
                <Chapters onOpen={setLightbox} />
                <Principles />
                <FinalCTA />
            </main>
            <Footer />
            <Lightbox item={lightbox} onClose={closeLightbox} />
        </div>
    );
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <MotionConfig reducedMotion="user">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                </Routes>
            </BrowserRouter>
        </MotionConfig>
    );
}

export default App;
